import { Divider, Drawer, Input, List } from 'antd';
import { debounce, includes, toLower } from 'lodash';
import { Search } from 'lucide-react';
import React, { useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { useSelector } from 'react-redux';
import { formatChatTime } from '../../utils/chatTimeFormat';

const SearchDrawer = ({ open, onClose, onClick }) => {
    const { messages, activeUser } = useSelector((state) => state.messageSlice);
    const [filteredMessages, setFilteredMessages] = useState([]);
    const [search, setSearch] = useState('');
    const inputRef = useRef(null);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearch(value);
        debouncedSearch(e.target.value);
    };

    const debouncedSearch = debounce((query) => {
        if (query.trim()) {
            const lowerCaseQuery = toLower(query);
            setFilteredMessages(messages.filter((msg) => includes(toLower(msg.message), lowerCaseQuery)));
        } else {
            setFilteredMessages([]);
        }
    }, 300);

    return (
        <Drawer
            title="Search messages"
            open={open}
            width={600}
            onClose={onClose}
            classNames={{
                body: ['px-0 pb-0', 'SearchDrawerBody'],
            }}
            afterOpenChange={(open) => {
                if (open) inputRef.current?.focus();
            }}
        >
            <div className="SearchDrawerBody__Container px-6">
                <Input
                    ref={inputRef}
                    placeholder="Search..."
                    size="large"
                    autoFocus={true}
                    prefix={<Search size={18} color="rgb(156,163,175)" />}
                    value={search}
                    onChange={handleSearch}
                />
            </div>
            <Divider className="mb-0" />
            <div className="SearchDrawerBody__body">
                <List
                    size="small"
                    bordered={false}
                    dataSource={filteredMessages}
                    locale={{
                        emptyText:
                            search.length
                                ? 'No messages found'
                                : `Search for messages with ${activeUser?.name}`,
                    }}
                    renderItem={(item) => (
                        <List.Item className="px-6" onClick={() => onClick(item)}>
                            <div className="date">{formatChatTime(item?.createdAt)}</div>
                            <div className="truncate">
                                <Highlighter
                                    highlightClassName="highlighted-text-color"
                                    searchWords={[search]}
                                    autoEscape
                                    textToHighlight={item?.message}
                                />
                            </div>
                        </List.Item>
                    )}
                />
            </div>
        </Drawer>
    );
};

export default SearchDrawer;
